module.exports = __webpack_public_path__ + "assets/img/cnodejs_light.86f6a7c2.svg";